// extracted by mini-css-extract-plugin
export default {"navsub":"NavSub_navsub__BUDLD"};